
import { defineComponent } from "vue";
import sendForm from "@/use/sendForm";
export default defineComponent({
  setup() {
    const {fromName, toName, message, sendEmail } = sendForm();
    return {fromName, toName, message, sendEmail}
  },
});
